import type { ComponentOverrides } from 'theme/theme.types';

export const MuiStack: ComponentOverrides['MuiStack'] = {
  defaultProps: {
    useFlexGap: true,
  },
};
